module.exports = __webpack_public_path__ + "static/media/laccomo.95fd75bc.jpg";